import React from 'react';
import {Route, Routes} from "react-router-dom";
import Xisobot1 from "./Xisobot1";
import Xisobot2 from "./Xisobot2";
import Xisobot3 from "./Xisobot3";
import Xisobot4 from "./Xisobot4";
import Xisobot5 from "./Xisobot5";
import Xisobot6 from "./Xisobot6";
import Xisobot7 from "./Xisobot7";
import Xisobot8 from "./Xisobot8";
import Xisobot9 from "./Xisobot9";
import Xisobot10 from "./Xisobot10";

function Index(props) {
    return (
        <Routes>
            <Route path="/" element={<Xisobot1 />}/>
            <Route path="/table2" element={<Xisobot2 />}/>
            <Route path="/table3" element={<Xisobot3 />}/>
            <Route path="/table4" element={<Xisobot4 />}/>
            <Route path="/table5" element={<Xisobot5 />}/>
            <Route path="/table6" element={<Xisobot6 />}/>
            <Route path="/table7" element={<Xisobot7 />}/>
            <Route path="/table8" element={<Xisobot8 />}/>
            <Route path="/table9" element={<Xisobot9 />}/>
            <Route path="/table10" element={<Xisobot10 />}/>
        </Routes>
    );
}

export default Index;